import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';

/// Saudação de um canal. `source` é o ELeadSource.
export interface AutoReplyChannel {
    source: number;
    message: string;
}

/// Avisar e mover lead parado saíram: a regra de coluna faz as duas, sabendo de qual coluna saiu.
export interface AutomationSettings {
    autoAssignEnabled: boolean;
    autoReplyEnabled: boolean;
    autoReplyMessage?: string | null;
    /// Canais com mensagem própria. Canal fora da lista usa a geral.
    autoReplyChannels: AutoReplyChannel[];
}

export enum EStageTrigger {
    OnEnter = 0,
    AfterDaysIdle = 1,
    AfterDaysNoReply = 2,
    OnWon = 3,
    OnLost = 4,
    BeforeSchedule = 5,
    AfterScheduleDone = 6,
}

export enum EStageAction {
    SendMessage = 0,
    CreateTask = 1,
    Assign = 2,
    MoveToColumn = 3,
    SetStatus = 4,
}

/// Os gatilhos que usam o campo de prazo. Os de desfecho não têm prazo.
export const TRIGGERS_WITH_DUE_DATE = [
    EStageTrigger.AfterDaysIdle,
    EStageTrigger.AfterDaysNoReply,
];

/// Uma regra presa a uma etapa do funil; diferente da configuração acima, que vale para o CRM inteiro.
export interface StageAutomation {
    id: string;
    boardColumnId: string;
    boardColumnName: string;
    name: string;
    enabled: boolean;
    trigger: EStageTrigger;
    idleDays: number;
    action: EStageAction;
    messageText?: string | null;
    taskDescription?: string | null;
    taskDueInDays: number;
    targetColumnId?: string | null;
    assignUserId?: string | null;
    targetStatusId?: string | null;
    hoursBefore: number;
    delayHours: number;
    conditionMinValue?: number | null;
    conditionSource?: number | null;
    sortOrder: number;
}

export type StageAutomationInput = Omit<
    StageAutomation, 'id' | 'boardColumnName' | 'sortOrder'
>;

export class AutomationService extends BaseService {
    protected get resourceName(): string {
        return 'crm/automations';
    }

    public async load(): Promise<AxiosResponse<{ data: AutomationSettings }>> {
        return await this.get('');
    }

    public async save(body: AutomationSettings): Promise<AxiosResponse<{ data: AutomationSettings }>> {
        return await this.put('', body);
    }

    public async stages(boardId: string): Promise<AxiosResponse<{ data: StageAutomation[] }>> {
        return await this.get(`stages/${boardId}`);
    }

    public async createStage(
        body: StageAutomationInput
    ): Promise<AxiosResponse<{ data: StageAutomation }>> {
        return await this.post(body, 'stages');
    }

    public async updateStage(
        id: string,
        body: StageAutomationInput
    ): Promise<AxiosResponse<{ data: StageAutomation }>> {
        return await this.put(`stages/${id}`, body);
    }

    public async deleteStage(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(`stages/${id}`);
    }
}
